import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/models';
import { Button, Form, Input, Select, message } from 'antd';
import EmailList from '../../../components/emailList';
import cx from 'classnames';
import cs from '../../index.module.scss';
import SelectArrowIcon from '@/components/icons/SelectArrowIcon';
import EyeShowIcon from '@/components/icons/EyeShowIcon';
import EyeHideIcon from '@/components/icons/EyeHideIcon';
import '@/lib/gt';
import encrypt from '@/utils/encrypt';

const { Option } = Select;
const FirstStep: React.FC = () => {
  const { t } = useTranslation();
  const { account, ui } = useStore();
  const {
    lang,
    fetchisExit,
    countryList,
    setLoginUserName,
    setLoginFisrtStepVisible,
    setLoginLastStepVisible,
    setGeeResult,
    fetchLoginTokenInfo,
    fetchSendCode,
    fetchInit,
    geeResult,
    loginUserName,
  } = account;
  const captchaObj = useRef<any>(null);
  const [loading, setLoading] = useState(false); // 第一个登录按钮
  const [type, setType] = useState('');
  const inputRef = useRef(null);
  const [showPsw, setShowPsw] = useState(false); // 展示密码
  const [currentTab, setCurrentTab] = useState('email');
  const [userName, setUserName] = useState('');
  const [form] = Form.useForm();
  const { push } = useHistory();
  useEffect(() => {
    inputRef.current?.focus({
      cursor: 'end',
    });
  }, [showPsw]);
  const handleCurrentTab = (value: string) => {
    form.resetFields();
    setCurrentTab(value);
  };

  const prefixSelector = (
    <Form.Item name="telCountryCode" noStyle>
      <Select
        // style={{ width: 84 }}
        optionLabelProp="label"
        dropdownMatchSelectWidth={false}
        suffixIcon={<SelectArrowIcon />}
        className="selectNormal"
      >
        {countryList?.map((_: any) => (
          <Option value={_.code} key={_.id} label={`+${_.code}`} className="option">
            +{_.code} {lang === 'zh' ? _.zh : _.en}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
  const sendCode = judgeToken => {
    const data = {
      username: form.getFieldValue('username'),
      telCountryCode: form.getFieldValue('telCountryCode'),
      judgeToken,
    };
    return fetchSendCode(data);
  };
  const onFinish = (values: any) => {
    const { telCountryCode, username, password } = values;
    const data = {
      password: encrypt(password),
      username,
      telCountryCode,
    };
    setUserName(username);
    setLoginUserName(data);
    // setLoading(true);

    if (type === 'neteasy') {
      captchaObj.current && captchaObj.current.verify();
    } else {
      captchaObj.current && captchaObj.current.showCaptcha();
    }
  };

  const isExit = async geetest => {
    setGeeResult(geetest);
    const params = {
      userName: form.getFieldValue('username'),
      countryCode: form.getFieldValue('telCountryCode'),
      geetest: JSON.stringify(geetest),
    };
    const judgeResult = await fetchisExit(params);
    if (!judgeResult) {
      setLoading(false);
      return;
    }
    const { exist, judgeToken } = judgeResult;
    if (exist) {
      const data = {
        username: form.getFieldValue('username'),
        telCountryCode: form.getFieldValue('telCountryCode'),
        password: encrypt(form.getFieldValue('password')),
        geetest: JSON.stringify(geetest),
        judgeToken,
      };
      fetchLoginTokenInfo(data)
        .then(async res => {
          if (res) {
            const { code } = res;
            if ([-10021, -10025].includes(code)) {
              await sendCode(judgeToken);
              setLoginFisrtStepVisible(false);
              setLoginLastStepVisible(true);
            }
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      message.error(t('findpsw.noexit'));
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchInit().then(({ gt, new_captcha, type }) => {
      if (!new_captcha) return;
      setType(type);
      if (type === 'neteasy') {
        initNECaptcha(
          {
            captchaId: gt,
            element: '#elementId',
            mode: 'popup',
            width: '320px',
            apiVersion: 2,
            lang: lang === 'zh' ? 'zh-CN' : 'en',
            popupStyles: {
              position: 'fixed',
              top: '20%',
              // top: '100px',
              // right: '50px',
            },
            onVerify: (err, data) => {
              // 当验证失败时, 内部会自动 refresh 方法, 无需手动再调用一次
              if (err) return;
              // 以下为业务侧逻辑
              isExit(data);
              // captchaObj.current && captchaObj.current.refresh();
            },
            onClose: () => {
              setLoading(false);
              captchaObj.current && captchaObj.current.refresh();
            },
          },
          instance => {
            captchaObj.current = instance;
            // setCaptchaObj(instance);
          },

          err => {
            // 初始化失败后触发该函数, err 对象描述当前错误信息
            console.log(err, 'err');
          },
        );

        // document.querySelector('#elementId').addEventListener('click', () => {
        //   captchaObj && captchaObj.verify();
        // });
      } else if (type === 'aliyun') {
        initAlicom4(
          {
            captchaId: gt,
            product: 'bind',
            language: lang === 'zh' ? 'zho' : 'eng',
          },
          captcha => {
            captchaObj.current = captcha;
            // captcha为验证码实例
            // setCaptchaObj(captcha);
            captcha
              .onReady(() => {
                // 验证码ready之后才能调用verify方法显示验证码
              })
              .onSuccess(() => {
                const result = captcha.getValidate();

                isExit({ ...result, graphicType: 'GEETEST' });
              })
              .onClose(() => {
                setLoading(false);
              })
              .onError(() => {
                // your code
              });
          },
        );
        return;
      } else {
        initGeetest4(
          {
            captchaId: gt,
            product: 'bind',
            language: lang === 'zh' ? 'zho' : 'eng',
          },
          captcha => {
            captchaObj.current = captcha;
            // captcha为验证码实例
            // setCaptchaObj(captcha);
            captcha
              .onReady(() => {
                // 验证码ready之后才能调用verify方法显示验证码
              })
              .onSuccess(() => {
                const result = captcha.getValidate();

                isExit(result);
                // if (!result) {
                //   return alert('请完成验证');
                // }
              })
              .onClose(() => {
                setLoading(false);
              })
              .onError(() => {
                // your code
              });
          },
        );
      }
    });
  }, []);
  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const [showEmailList, setShowEmailList] = useState(false);

  const [username, setUsername] = useState(loginUserName.username || '');

  useEffect(() => {
    setUsername(loginUserName.username || '');
  }, [loginUserName.username]);

  useEffect(() => {
    form.setFieldsValue({ username });
  }, [form, username]);

  return (
    <div className={cs.content}>
      <div className={cx(cs.content_info)}>
        <div className={cs.tab}>
          <span onClick={() => handleCurrentTab('email')} className={currentTab === 'email' ? cs.active : ''}>
            {t('common.email')}
          </span>
          {/* 临时注释手机号
          <span className={currentTab === 'phone' ? cs.active : ''} onClick={() => handleCurrentTab('phone')}>
            {t('common.tel')}
          </span> */}
        </div>
        <Form
          form={form}
          name="basic"
          labelCol={{ flex: 1 }}
          wrapperCol={{ flex: 1 }}
          labelAlign="left"
          initialValues={{ telCountryCode: '86', username: loginUserName.username }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="vertical"
          requiredMark={false}
        >
          {currentTab === 'phone' ? (
            <Form.Item name="username" rules={[{ required: true, message: t('common.srsjhm') }]}>
              {/* allowClear={{ clearIcon: chaCom }} */}
              <Input addonBefore={prefixSelector} className="bgIptAddonBefore" allowClear placeholder={t('common.srsjhm')} />
            </Form.Item>
          ) : (
            <Form.Item name="username" rules={[{ required: true, type: 'email', message: t('common.srzqdyxgs') }]}>
              <>
                <Input
                  placeholder={t('common.emailPlace')}
                  onChange={e => {
                    setUsername(e.target.value);
                    setShowEmailList(true); // 在输入时显示邮箱列表
                  }}
                  value={username}
                  className="iptDefault"
                  onBlur={() => {
                    setTimeout(() => setShowEmailList(false), 200); // 🔹 失焦时隐藏（延迟避免点击列表时消失）
                    form.setFieldsValue({ username });
                  }}
                />
                {showEmailList && username && (
                  <EmailList
                    curValue={username} // 绑定表单 username
                    chooseEmail={selectedEmail => {
                      setUsername(selectedEmail);
                      setShowEmailList(false);
                    }}
                  />
                )}
              </>
            </Form.Item>
          )}
          <Form.Item
            name="password"
            rules={[
              { required: true, message: t('common.enterpsd') },

              ({ getFieldValue }) => ({
                validator(_, value) {
                  // 空值由 required 规则处理，避免 value.length 抛错导致显示"字段验证错误"
                  if (!value) {
                    return Promise.resolve();
                  }
                  if (value.length >= 8 && value.length <= 22) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t('common.psdrule')));
                },
              }),
            ]}
          >
            <Input
              placeholder={t('common.enterpsd')}
              ref={inputRef}
              maxLength={22}
              type={showPsw ? 'text' : 'password'}
              className="iptSuffix"
              suffix={
                showPsw ? (
                  <EyeShowIcon
                    onClick={() => {
                      setShowPsw(!showPsw);
                    }}
                  />
                ) : (
                  <EyeHideIcon
                    onClick={() => {
                      setShowPsw(!showPsw);
                    }}
                  />
                )
              }
            />
          </Form.Item>

          <div className={cs.btn}>
            <Button
              loading={loading}
              type="primary"
              htmlType="submit"
              className={cx('btnPrimary', cs.registerBtn)}
              style={{ height: '40px', width: '100%' }}
            >
              {t('common.next')}
            </Button>
          </div>
          <div
            className={cx(cs.findpsw, 'pointer')}
            onClick={() => {
              // push('/findpsw');
              ui.hideLoginModal();
              ui.showFindPwdModal();
            }}
          >
            {t('common.forgetpsd')}?
          </div>
        </Form>
      </div>
    </div>
  );
};

export default observer(FirstStep);
